const environments = {

  staging: {
    url: process.env.REACT_APP_API_URL,
    chatbotUrl: process.env.REACT_APP_CHATBOT_URL,
    frontendUrl: process.env.REACT_APP_FRONTEND_URL
  },

  local: {
    url: process.env.REACT_APP_API_URL,
    chatbotUrl: process.env.REACT_APP_CHATBOT_URL,
    frontendUrl: process.env.REACT_APP_FRONTEND_URL
  },
  prod: {
    url: process.env.REACT_APP_API_URL,
    chatbotUrl: process.env.REACT_APP_CHATBOT_URL,
    frontendUrl: process.env.REACT_APP_FRONTEND_URL
  }
};
export default environments;
